<template>
    <div class="template-configuration">
        <el-row>
      <el-col :span="5" style="padding: 0 5px">
        <el-card
          body-style="height: 850px;"
          class="box-card devices-area"
          shadow="never"
        >
          <div
            style="width: 100%; height: 100%; overflow: auto"
            class="comp-tree"
          >
            <el-tree
              :data="treeData"
              node-key="unitName"
              ref="tree"
              row-key="id"
              :props="defaultProps"
              :highlight-current="true"
              default-expand-all
              class="ut-custom-tree-list"
               @node-click="treeClick" 
   
            >
                       <!---->
               <!--  -->
              <!-- :expand-on-click-node="false" 是否在点击节点的时候展开或者收缩节点， 默认值为 true，如果为 false，则只有点箭头图标的时候才会展开或者收缩节点 -->
              <div slot-scope="{ node ,data}">
                <!-- <i v-if="data.children" class="el-icon-folder-opened"></i>
                <i v-else class="el-icon-folder"></i> -->
                <!-- <img src="../../assets/energyApplication/文件夹.png"  style="vertical-align: bottom; width: 25px"/> -->
                <img src="../../../assets/rateTemplate/公司.png"  style="vertical-align: bottom; width: 25px"/>
                <div v-if="false">{{node}}</div>
                <span :class="['unit-name',{'active':data.no==1}]">{{ data.unitName }}</span>
                 <!-- <img src="../../../assets/rateTemplate/peizhi.png"  v-if="data.temId"/> -->
              </div>
            </el-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19" >
        <el-card
          body-style="height: 850px;backgroud-color:#edf2f9"
          class="box-card devices-area"
          shadow="never"
        >
        <div class="content ">
            
            <!-- <div class="titles">计费模板配置</div> -->
            <div class="head-peration">
                <div class="left">
                    选择计费模板：  <el-radio-group v-model="radio" >
                                        <el-radio :label="1"  size="20">单价模板</el-radio>
                                        <el-radio :label="2">阶梯模板</el-radio>
                                    </el-radio-group>
                </div>
                <!-- <div class="right">
                    <el-input placeholder="请输入名称" v-model="searchName"  suffix-icon="el-icon-date"></el-input>
                    <el-button type="primary" size="mini">重置</el-button>
                </div> -->
            </div>
            <!-- 单价表格 -->
            <div class="mytable unit-price" v-show="radio ==1">
                <div class="item">
                    <div class="item-title">电费计价配置</div>
                    <el-table :data="unitElectric"  height="221" border style="width: 100%" >
                           <el-table-column label="序号" width="70">
                                <template slot-scope="scope">
                                <span>{{ (scope.$index) + 1}}</span>
                            </template>
                            </el-table-column>
                        <el-table-column   label="配置"  width="70">
                                   <template  slot-scope="scope">
                                       <input type="radio" name="unitElectricRadios" :value="scope.row.id" v-model="unitElectricRadio" />
                                        <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                                    </template>
                         </el-table-column>
                        <el-table-column  prop="temName"  label="计费名称" width="310">  </el-table-column>
                        <!-- <el-table-column  prop="name"  label="能源类型" width="260">  </el-table-column> -->
                           <el-table-column  prop="energyType" label="能源类型"  width="260">
                              <template slot-scope="scope">{{ scope.row.energyType | energyType }}</template>
                        </el-table-column>
                        <!-- <el-table-column  prop="name"  label="单位" width="200">  </el-table-column> -->
                         <el-table-column  prop="company" label="单位"  width="200">
                           <template slot-scope="scope">{{ scope.row.energyType | company }}</template>
                       </el-table-column>
                        <el-table-column  prop="singleChargingStandard"  label="计费单价（元）" width="337">  </el-table-column>
                    </el-table>
                </div>
                   <div class="item">
                    <div class="item-title">水费计价配置</div>
                    <el-table :data="unitWater"  height="221" border style="width: 100%" >
                                <el-table-column label="序号" width="70">
                                <template slot-scope="scope">
                                <span>{{ (scope.$index) + 1}}</span>
                            </template>
                            </el-table-column>
                        <el-table-column    label="配置"  width="70">
                                   <template slot-scope="scope">
                                       <input type="radio" name="unitWaterRadios" :value="scope.row.id" v-model="unitWaterRadio" />
                                        <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                                    </template>
                         </el-table-column>
                        <el-table-column  prop="temName"  label="计费名称" width="310">  </el-table-column>
                        <!-- <el-table-column  prop="name"  label="能源类型" width="260">  </el-table-column> -->
                           <el-table-column  prop="energyType" label="能源类型"  width="260">
                              <template slot-scope="scope">{{ scope.row.energyType | energyType }}</template>
                        </el-table-column>
                        <!-- <el-table-column  prop="name"  label="单位" width="200">  </el-table-column> -->
                         <el-table-column  prop="company" label="单位"  width="200">
                        <template slot-scope="scope">{{ scope.row.energyType | company }}</template>
                       </el-table-column>
                        <el-table-column  prop="singleChargingStandard"  label="计费单价（元）" width="337">  </el-table-column>
                    </el-table>
                </div>
                   <div class="item">
                    <div class="item-title">气费计价配置</div>
                    <el-table :data="unitGas"  height="221" border style="width: 100%" >
                               <el-table-column label="序号" width="70">
                                <template slot-scope="scope">
                                <span>{{ (scope.$index) + 1}}</span>
                            </template>
                            </el-table-column>
                        <el-table-column   label="配置"  width="70">
                                   <template slot-scope="scope">
                                       <input type="radio" name="unitGasRadios"  :value="scope.row.id" v-model="unitGasRadio" />
                                        <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                                    </template>
                         </el-table-column>
                        <el-table-column  prop="temName"  label="计费名称" width="310">  </el-table-column>
                        <!-- <el-table-column  prop="name"  label="能源类型" width="260">  </el-table-column> -->
                           <el-table-column  prop="energyType" label="能源类型"  width="260">
                              <template slot-scope="scope">{{ scope.row.energyType | energyType }}</template>
                        </el-table-column>
                        <!-- <el-table-column  prop="name"  label="单位" width="200">  </el-table-column> -->
                         <el-table-column  prop="company" label="单位"  width="200">
                        <template slot-scope="scope">{{ scope.row.energyType | company }}</template>
                       </el-table-column>
                        <el-table-column  prop="singleChargingStandard"  label="计费单价（元）" width="337">  </el-table-column>
                    </el-table>
                </div>
                 <div class="btn">
                     <el-button    size="small" type="primary" @click="preservationFun(radio)">保存</el-button>
                </div>
            </div>
            <!-- 阶梯表格 -->
              <div class="mytable ladder" v-show="radio ==2">
                <div class="item">
                    <div class="item-title">电费计价配置</div>
                    <el-table :data="ladderElectric"  height="221" border style="width: 100%" >
                           <el-table-column label="序号" width="70">
                                <template slot-scope="scope">
                                <span>{{ (scope.$index) + 1}}</span>
                            </template>
                            </el-table-column>
                        <el-table-column   label="配置"  width="70">
                                   <template>
                                       <input type="radio" name="ladderElectricRadios"  v-model="ladderElectricRadio" />
                                        <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                                    </template>
                         </el-table-column>
                        <el-table-column  prop="temName"  label="计费名称" width="310">  </el-table-column>
                        <el-table-column  prop="energyType" label="能源类型"  width="260">
                              <template slot-scope="scope">{{ scope.row.energyType | energyType }}</template>
                        </el-table-column>
                        <!-- <el-table-column  prop="name"  label="单位" width="200">  </el-table-column> -->
                         <el-table-column  prop="company" label="单位"  width="200">
                           <template slot-scope="scope">{{ scope.row.energyType | company }}</template>
                       </el-table-column>
                        <el-table-column    label="计费单价（元）" width="337"> 
                             <template slot-scope="scope">
                                      <el-popover :ref="`popover-${scope.$index}`"  placement="left">
                                           <div class="titles">{{scope.row.temName}}</div>
                                               <div class="items" style="display: flex;justify-content: space-between;  margin-top: 10px;" 
                                               v-for="item in scope.row.stepSection" :key="item.temName"
                                               >{{item.sectionName | sectionNameFun}}：<span style="margin:0px 10px">{{item.startMeter}} - {{item.endMeter}} kw·h</span> <span>{{item.stepValue}}元/kw·h</span></div>
                                        <!-- popover 触发源 -->
                                        <el-button type="text" slot="reference">查看详情</el-button>
                                    </el-popover>

                                      
                                        <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                                </template>
                             </el-table-column>
                    </el-table>
                </div>
                 <div class="item">
                    <div class="item-title">水费计价配置</div>
                    <el-table :data="ladderWater"  height="221" border style="width: 100%" >
                           <el-table-column label="序号" width="70">
                                <template slot-scope="scope">
                                <span>{{ (scope.$index) + 1}}</span>
                            </template>
                            </el-table-column>
                        <el-table-column   label="配置"  width="70">
                                   <template>
                                       <input type="radio" name="ladderWaterRadios"  v-model="ladderWaterRadio" />
                                        <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                                    </template>
                         </el-table-column>
                        <el-table-column  prop="temName"  label="计费名称" width="310">  </el-table-column>
                      <el-table-column  prop="energyType" label="能源类型"  width="260">
                              <template slot-scope="scope">{{ scope.row.energyType | energyType }}</template>
                        </el-table-column>
                        <!-- <el-table-column  prop="name"  label="单位" width="200">  </el-table-column> -->
                         <el-table-column  prop="company" label="单位"  width="200">
                           <template slot-scope="scope">{{ scope.row.energyType | company }}</template>
                       </el-table-column>
                          <el-table-column    label="计费单价（元）" width="337"> 
                             <template slot-scope="scope">
                                      <el-popover :ref="`popover-${scope.$index}`"  placement="left">
                                           <div class="titles">{{scope.row.temName}}</div>
                                               <div class="items" style="display: flex;justify-content: space-between;  margin-top: 10px;" 
                                               v-for="item in scope.row.stepSection" 
                                               :key="item.temName"
                                               >{{item.sectionName | sectionNameFun}}：<span style="margin:0px 10px">{{item.startMeter}} - {{item.endMeter}} kw·h</span> <span>{{item.stepValue}}元/kw·h</span></div>
                                        <!-- popover 触发源 -->
                                        <el-button type="text" slot="reference">查看详情</el-button>
                                    </el-popover>

                                      
                                        <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                                </template>
                             </el-table-column>
                    </el-table>
                </div>
                 <div class="item">
                    <div class="item-title">气费计价配置</div>
                    <el-table :data="ladderGas"  height="221" border style="width: 100%" >
                           <el-table-column label="序号" width="70">
                                <template slot-scope="scope">
                                <span>{{ (scope.$index) + 1}}</span>
                            </template>
                            </el-table-column>
                        <el-table-column  prop="name"  label="配置"  width="70">
                                   <template>
                                       <input type="radio" name="ladderGasRadios"  v-model="ladderGasRadio" />
                                        <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                                    </template>
                         </el-table-column>
                        <el-table-column  prop="temName"  label="计费名称" width="310">  </el-table-column>
                        <el-table-column  prop="energyType" label="能源类型"  width="260">
                              <template slot-scope="scope">{{ scope.row.energyType | energyType }}</template>
                        </el-table-column>
                        <!-- <el-table-column  prop="name"  label="单位" width="200">  </el-table-column> -->
                         <el-table-column  prop="company" label="单位"  width="200">
                           <template slot-scope="scope">{{ scope.row.energyType | company }}</template>
                       </el-table-column>
                        <el-table-column    label="计费单价（元）" width="337"> 
                             <template slot-scope="scope">
                                      <el-popover :ref="`popover-${scope.$index}`"  placement="left">
                                           <div class="titles">{{scope.row.temName}}</div>
                                           <div class="items" style="display: flex;justify-content: space-between;  margin-top: 10px;" 
                                           v-for="item in scope.row.stepSection"
                                            :key="item.temName"
                                            >{{item.sectionName | sectionNameFun}}：<span style="margin:0px 10px">{{item.startMeter}} - {{item.endMeter}} kw·h</span> <span>{{item.stepValue}}元/kw·h</span></div>
                                        <!-- popover 触发源 -->
                                        <el-button type="text" slot="reference">查看详情</el-button>
                                    </el-popover>

                                      
                                        <!-- @change="changeFun(scope.row.defaultStatus,scope.row.temId)" -->
                                </template>
                             </el-table-column>
                    </el-table>
                </div>
         
                  
                 <div class="btn">
                     <el-button    size="small" type="primary"  @click="preservationFun(radio)">保存</el-button>
                </div>
            </div>
        </div>
       
        </el-card>
      </el-col>
    </el-row>
    </div>
</template>

<script>
// import {getRateTree} from "../../../api/rateConfiguration";
import {findUnitTreeIsTem,findSingleTemplateList,stepBillingTemp,bindingUnitAndTem} from "../../../api/reading";
export default {
  data() {
    return {
      gridData: [],
      unitElectric:[],//单价电计费
      unitGas:[],//单价气计费
      unitWater:[],//单价水计费
      unitElectricRadio:1, //单价电单选框
      unitGasRadio:1,//单价气单选框
      unitWaterRadio:1,//单价水单选框

      ladderElectric:[],//阶梯电计费
      ladderGas:[],//阶梯气计费
      ladderWater:[],//阶梯水计费
      ladderElectricRadio:1, //阶梯电单选框
      ladderGasRadio:1,//阶梯气单选框
      ladderWaterRadio:1,//阶梯水单选框

      radio:1,
      param:"",
      treeData:[], //树形结构数据
      defaultProps: {
        children: "children",
        unitName: "unitName",
      },
      searchName:"",//搜索框名称
      checked:true, // 查看全部按钮
      param:"", //默认选中
      temDate:null,//首页费率模板数据
      treeUnitId:"", // 树形数据的id
      temId:"", //单选框选中模板id
        tableData: []
    };
  },
  mounted(){
    //    this.treeData = localStorage.getItem("treeList")
    //    console.log("treeList",this.);
    this.findUnitTreeIsTemFun()
    this.getList()
  },
    methods: {
         //表格样式
    headerStyle() {
		  return {
		    background: "#f3f8ff",
		    textAlign: "center",
		    color: "#999999",
		  	fontSize:"18px",
        fontWeight: "bold",
        borderColor:"#999999"
		  };
		},
            // 获取树形数据
    findUnitTreeIsTemFun(){
      findUnitTreeIsTem().then(data => {
        // console.log("data.data[0]",data.data[0]);
            this.treeData.push(data.data[0]) 
      })
    },
    preservationFun(type){
      //  console.log("this.treeUnitId",this.treeUnitId);
       if(this.treeUnitId == ""){
          this.operationFun("warning","请选择左边树形中的公司")
          return
       }
      
      
      if(type == 1){
        let temIdArr = []
       if(this.unitElectricRadio != 1 ){
          // temIdArr.push(this.unitElectricRadio)
          // temIdArr += ","+this.unitElectricRadio
           temIdArr.push({
            "energyType":"ELECTRIC",
            "temId":this.unitElectricRadio
          })
       }
        if(this.unitGasRadio != 1 ){
          // temIdArr.push(this.unitGasRadio)
          // temIdArr += ","+this.unitElectricRadio
           temIdArr.push({
            "energyType":"GAS",
            "temId":this.unitGasRadio
          })
       }
        if(this.unitWaterRadio != 1 ){
          // temIdArr.push(this.unitWaterRadio)
          // temIdArr += ","+this.unitElectricRadio
           temIdArr.push({
            "energyType":"WATER",
            "temId":this.unitWaterRadio
          })
       }
        if(temIdArr.length == 0){
           this.operationFun("warning","请至少选择一个模板")
           return
       }
         let d = {
            "energyTypeBilling":temIdArr,
            "unitNo":this.treeUnitId,
            "billingType":0
          }
          console.log("d",d);
        bindingUnitAndTem(d).then(res => {
          // console.log("返回数据",res);
          if(res.code ==200){
             this.operationFun("success","绑定成功")
            temIdArr  = []
          }else {
             this.operationFun("warning","绑定失败")
          }

        })
        // console.log("unitElectricRadio",this.unitElectricRadio);
        // console.log("unitGasRadio",this.unitGasRadio);
        // console.log("unitWaterRadio",this.unitWaterRadio);
      }else if(type ==2){
       
        let laddertemIdArr = ""
       if(this.ladderElectricRadio != 1 ){
          // laddertemIdArr += ","+this.ladderElectricRadio
           laddertemIdArr.push({
            "energyType":"ELECTRIC",
            "temId":this.ladderElectricRadio
          })
       }
        if(this.ladderGasRadio != 1 ){
          //  laddertemIdArr += ","+this.ladderGasRadio
           laddertemIdArr.push({
            "energyType":"GAS",
            "temId":this.ladderGasRadio
          })
       }
        if(this.ladderWaterRadio != 1 ){
          // laddertemIdArr += ","+this.ladderWaterRadio
           laddertemIdArr.push({
            "energyType":"WATER",
            "temId":this.ladderWaterRadio
          })
       }
        if(laddertemIdArr.length == 0){
           this.operationFun("warning","请至少选择一个模板")
           return
       }
         let b = {
            "energyTypeBilling":laddertemIdArr,
            "unitNo":this.treeUnitId,
            "billingType":1
          }
         bindingUnitAndTem(b).then(res => {
          // console.log("返回数据",res);
          if(res.code ==200){
             this.operationFun("success","绑定成功")
            laddertemIdArr  = []
          }else {
             this.operationFun("warning","绑定失败")
          }

        })
      }
    },
    //获取数据
      getList(){
        // 获取单价计费模板数据
        findSingleTemplateList().then(data => {
            // this.temDate = data.data
            // this.maskFlag = false
            //  this.tranStatus(this.temDate)
            this.unitElectric = data.data.filter(item => item.energyType == "ELECTRIC")
            this.unitGas = data.data.filter(item => item.energyType == "GAS")
            this.unitWater = data.data.filter(item => item.energyType == "WATER")
            
           })
          //  .catch(() => {
          //        this.maskFlag = false
          //  })
            // 获取阶梯计费模板数据
          stepBillingTemp().then(data => {
            this.ladderElectric = data.data.filter(item => item.energyType == "ELECTRIC")
            this.ladderGas = data.data.filter(item => item.energyType == "GAS")
            this.ladderWater = data.data.filter(item => item.energyType == "WATER")
          })
      },
       //操作提醒
     operationFun(types,describe){
          this.$message({
             type: types,
             message: describe,
             duration:1500,
             offset:150
          });
    },
      //节点点击
      treeClick(a){
        // console.log(a);
        this.treeUnitId = a.no
        // if(a.temId){
        //    let index = this.temDate.findIndex(item => item.id == a.temId)
        //    this.param = index
        // }else {
        //   this.param = ""
        // }
      },
    },
     //过滤器
  filters:{
    //能源类型 ELECTRIC(电)  WATER(水) GAS(气)
    energyType(val){
      if(val == 'ELECTRIC'){
        return "电"
      }else if(val == 'WATER'){
        return "水"
      }else {
        return "气"
      }
    },
     //单位类型
      company(val){
      if(val == 'ELECTRIC'){
        return "kw·h"
      }else if(val == 'WATER'){
        return "t"
      }else {
        return "m³"
      }
    },
    //阶梯名称
    sectionNameFun(val){
      if(val == '第1阶梯'){
        return "第一阶梯"
      }else if(val == '第2阶梯'){
        return "第二阶梯"
      }else if(val == '第3阶梯'){
        return "第三阶梯"
      }else {
        return val
      }
    },
    // 转换时间戳
    "date_format":function (value) { //value就是插值的数据
      let date = new Date(value);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';

      let h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
      let strDate = Y + M + D + h + m + s;
       return strDate
    },
  }
}
</script>

<style lang="scss" scoped>
.template-configuration {
     
        .titles {
            font-size: 17px;
            color: #333;
            font-weight: bold;
        }
        .head-peration {
            display: flex;
            justify-content: space-between;
            align-items: center;
             .left {
                font-size: 16px;
                /deep/.el-radio__label {
                    font-size: 16px;
                }
             }
             .right {
                width: 300px;
                display: flex;
                /deep/.el-input__inner {
                    height: 35px;
                }
                button {
                    margin-left: 10px;
                }
             }
        }
        .mytable {
            .item{
                height: 250px;
                max-height: 250px;
                margin-top: 10px;
                .item-title {
                    font-size: 15px;
                    font-weight: bold;
                    color: #999999;
                    margin-bottom: 10px;
                }
                 /deep/th,
                 /deep/td {
                    padding: 0;
                    height: 44px;
                    text-align: center;
                 }
                 /deep/th  {
                    background-color: #F3F8FF !important;
                 }
              }
              .btn {
                display: flex;
                align-items: center;
                   justify-content: flex-end;
                 width: 100%;
                 margin-top: 10px;
                 button {
                    margin-right: 9px;

                 }
              }
        }
        .ladder {
            /deep/.el-popover {
                background-color: red;
            }
            /deep/.el-popper {
                background-color: red;
            }
            .titles {
                font-size: 16px;
                font-weight: bold;
                color: #52A1FF;
            }
  
           
        }
}

</style>

